var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1973352730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2288"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#60B0F9",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.67656,
    stroke: "url(#paint0_linear_17475_24123)",
    strokeOpacity: 0.3,
    strokeWidth: 0.646875
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.84635 5.34635C8.73567 5.23567 8.58564 5.17342 8.42893 5.17318C8.27222 5.17294 8.12243 5.23544 8.01151 5.34635L6.09567 7.26219L6.09567 6.18548C6.10832 6.02162 6.05178 5.85966 5.94039 5.73872C5.82876 5.61803 5.67157 5.54957 5.50723 5.54933C5.34265 5.54934 5.1857 5.61803 5.07407 5.73872C4.96244 5.85942 4.90591 6.02138 4.91879 6.18548L4.91879 8.69C4.91831 8.84743 4.98033 8.99865 5.09172 9.11004C5.20311 9.22144 5.3541 9.28369 5.51176 9.28298L8.01628 9.28297C8.21593 9.26747 8.39387 9.15202 8.48952 8.97623C8.58516 8.80044 8.58516 8.58815 8.48952 8.41236C8.39387 8.23656 8.21593 8.12112 8.01652 8.10585L6.93123 8.09726L8.84683 6.18167C8.9575 6.07099 9.01976 5.92096 9.02 5.76425C9.02023 5.60754 8.95703 5.45703 8.84635 5.34635Z",
    fill: "#8DC8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17475_24123",
    x1: -3.675,
    y1: -20.65,
    x2: 7,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckin);
export default __webpack_public_path__ + "static/media/Checkin.fb86cd208eb6e3134c568f7dfd72394c.svg";
export { ForwardRef as ReactComponent };